var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlass5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 51,
    viewBox: "0 0 25 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15034_2050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94432 0.0823333L18.057 -0.000711687C18.057 -0.000711687 19.0252 -0.121819 19.0686 1.12732C19.1119 2.37645 19.0686 5.48026 19.0686 5.48026L6.06282 5.40067V0.808977C6.06282 0.808977 6.01946 0.123856 6.94793 0.0823333H6.94432Z",
    fill: "#5A3CCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.4181C0 17.4181 8.24783 19.2728 12.4169 16.6915C13.5116 16.0064 17.9733 12.9026 24.9169 17.4977C25 12.9822 25 12.1759 25 12.1759C25 12.1759 24.9566 7.01675 19.0643 5.48388C12.3736 5.48388 6.05853 5.4043 6.05853 5.4043C6.05853 5.4043 0.335983 6.65343 0.0397399 12.297C0.0433526 16.6119 0 17.4181 0 17.4181Z",
    fill: "#CFE1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35286e-05 17.4196V47.6964C3.35286e-05 47.6964 -0.0433191 51.0009 2.98775 51.0009H21.8425C21.8425 51.0009 24.9133 51.0009 24.9567 48.0597C25 45.1186 24.9133 17.5026 24.9133 17.5026C24.9133 17.5026 18.6417 12.5442 12.4133 16.6964C11.026 17.34 9.72185 18.8314 3.35286e-05 17.4196Z",
    fill: "#7257D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8037 23.7366C21.8037 23.0849 21.2522 22.5566 20.5718 22.5566C19.8914 22.5566 19.3398 23.0849 19.3398 23.7366V36.5532C19.3398 37.2048 19.8914 37.7331 20.5718 37.7331C21.2522 37.7331 21.8037 37.2048 21.8037 36.5532V23.7366Z",
    fill: "#AE9BF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15034_2050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass5);
export default __webpack_public_path__ + "static/media/glass5.602e4916fe841dafdf3baa628aeefd82.svg";
export { ForwardRef as ReactComponent };